__turbopack_context__.v({
  "dividerWrapper": "OverviewRow-module-scss-module__VtDcgW__dividerWrapper",
  "overviewRowWrapper": "OverviewRow-module-scss-module__VtDcgW__overviewRowWrapper",
  "thumbWrapper": "OverviewRow-module-scss-module__VtDcgW__thumbWrapper",
});
